"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.sort");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _UD = _interopRequireDefault(require("@crud/UD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _cmsCmsGenerateReport = _interopRequireDefault(require("@/api/cmsCmsGenerateReport"));

var _index = _interopRequireDefault(require("./SubreportByout/index"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _vuex = require("vuex");

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {};
var _default = {
  name: 'report',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    udOperation: _UD.default,
    SubByOne: _index.default,
    draggable: _vuedraggable.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  dicts: [],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '报表',
      url: 'api/CmsGenerateReport/getReportData',
      idField: 'rowId',
      sort: [null],
      crudMethod: _objectSpread({}, _cmsCmsGenerateReport.default)
    });
  },
  created: function created() {
    this.crud.optShow.add = false;
    this.crud.optShow.edit = false;
    this.crud.optShow.del = false;
    this.crud.optShow.download = false;
    this.crud.optShow.refresh = false;
    this.crud.optShow.column = false;
    this.crud.optShow.search = false;
  },
  data: function data() {
    return {
      isFirst: false,
      outerVisible: false,
      innerVisible: false,
      rowId: '',
      title1: '',
      title2: '',
      queryTypes: {},
      queryType: {},
      titleData: [],
      configVisible: false,
      configColumns: [],
      outerData: [],
      innerData: [],
      reportData: [],
      penetrateList: [],
      cols: [{
        prop: 'contractNumber',
        label: '合同号',
        width: 150
      }],
      cities: [{
        prop: 'rowId',
        label: '报表id',
        width: 150
      }, {
        prop: 'reportName',
        label: '报表名称',
        width: 150
      }, {
        prop: 'sqlStatement',
        label: 'sql语句',
        width: 150
      }, {
        prop: 'isStoredProcedure',
        label: '是否为存储过程',
        width: 150
      }, {
        prop: 'createTime',
        label: '创建时间',
        width: 150,
        query: 'createTime',
        type: 'date'
      }],
      permission: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'user', 'filesUploadApi'])), {}, {
    visibleColumns: function visibleColumns() {
      return this.titleData.filter(function (item) {
        return item.show !== '0';
      });
    },
    hiddenConfigCols: function hiddenConfigCols() {
      return this.configColumns.filter(function (item) {
        return item.show === '0';
      });
    },
    visibleConfigCols: {
      get: function get() {
        return this.configColumns.filter(function (item) {
          return item.show !== '0';
        });
      },
      set: function set(newVisible) {
        var hidden = this.configColumns.filter(function (item) {
          return item.show === '0';
        });
        this.configColumns = [].concat((0, _toConsumableArray2.default)(newVisible.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            show: '1'
          });
        })), (0, _toConsumableArray2.default)(hidden));
      }
    }
  }),
  methods: (_methods = {
    isSearch: function isSearch() {
      this.isFirst = true;
      this.crud.refresh();
    },
    resetQuery: function resetQuery() {
      this.isFirst = true;
      this.queryType = {};
      this.queryUsers = {};
      this.crud.resetQuery();
    }
  }, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    var _this = this;

    // let ArticleList1 = this.$route.query
    var rowId = this.getParamQueryString(this.$route.fullPath, "rowId");
    this.query.rowId = rowId;
    this.rowId = rowId;
    var titleList = [];

    _cmsCmsGenerateReport.default.get(rowId).then(function (res) {
      titleList = JSON.parse(res.content[0].header); // this.titleData = JSON.parse(res.content[0].header);

      titleList.sort(function (a, b) {
        return a.sort - b.sort; // 升序排序
      });
      _this.titleData = titleList;
    });

    return this.isFirst;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterRefresh, function (crud) {// this.titleData = JSON.parse(crud.data[0].header);
    // let rowId  = crud.data[0].rowId
    // console.log(this.reportData)
  }), (0, _defineProperty2.default)(_methods, "getParamQueryString", function getParamQueryString(url, name) {
    var subStr = name + '=';

    if (url.indexOf(subStr) !== -1) {
      var arr = url.split(subStr);
      var sub1 = arr[1];

      if (sub1.indexOf('&') !== -1) {
        var arr2 = sub1.split('&');
        var sub2 = arr2[0];
        return sub2;
      } else {
        return sub1;
      }
    }

    return '';
  }), (0, _defineProperty2.default)(_methods, "openConfigDialog", function openConfigDialog() {
    this.configColumns = this.titleData.map(function (item) {
      return _objectSpread({}, item);
    });
    this.configVisible = true;
  }), (0, _defineProperty2.default)(_methods, "toggleConfigCol", function toggleConfigCol(col, toShow) {
    col.show = toShow ? '1' : '0';
  }), (0, _defineProperty2.default)(_methods, "moveAllToVisible", function moveAllToVisible() {
    this.configColumns.forEach(function (item) {
      item.show = '1';
    });
  }), (0, _defineProperty2.default)(_methods, "moveAllToHidden", function moveAllToHidden() {
    this.configColumns.forEach(function (item) {
      item.show = '0';
    });
  }), (0, _defineProperty2.default)(_methods, "saveColumnConfig", function saveColumnConfig() {
    var _this2 = this;

    var newOrder = [];
    this.visibleConfigCols.forEach(function (col) {
      newOrder.push(_objectSpread(_objectSpread({}, col), {}, {
        show: '1'
      }));
    });
    this.hiddenConfigCols.forEach(function (col) {
      newOrder.push(_objectSpread(_objectSpread({}, col), {}, {
        show: '0'
      }));
    });
    newOrder.forEach(function (item, i) {
      item.sort = i + 1;
    });
    this.titleData = newOrder;

    _cmsCmsGenerateReport.default.updateByHeader({
      rowId: this.rowId,
      header: this.titleData
    }).then(function () {
      _this2.configVisible = false;

      _this2.crud.toQuery();
    });
  }), (0, _defineProperty2.default)(_methods, "openSubreportByout", function openSubreportByout(rowId, params, data) {
    // this.$nextTick(()=>{
    //   setTimeout(this.$refs.SubByOne.init(rowId,params,data),3000)
    //
    // })
    // this.$router.push({path:'/cms/cmsGenerateReport/report/SubreportByout/index2',query:{rowId:14}})
    this.$router.push({
      path: '/cms/cmsGenerateReport/report/SubreportByout',
      name: 'index2',
      query: {
        rowId: 14
      }
    });
  }), _methods)
};
exports.default = _default;